import { ReactNode } from "react";

import { Box } from "@mui/material";

const MapOverlayControls = ({ children }: { children: ReactNode }) => (
	<Box
		sx={{
			backgroundColor: "background.paper",
			borderRadius: 1,
			boxShadow: 1,
			display: "flex",
			flexDirection: "column",
			gap: 1,
			padding: 1,
			position: "absolute",
			top: 60,
			left: 10,
			zIndex: 1,
		}}>
		{children}
	</Box>
);

export default MapOverlayControls;
